<template lang="pug">
  .component.component-backoffice-vehicle-cost(v-if="item")
    .card( v-if="$is('listing')")
      .inner-content
        cardN(:showBullets="true", :showAction="true", :columns="4")
          div(slot="actionBullets")
            dropdown(:icon="'fa fa-ellipsis-v fa-2x action'", :position="'top'")
              vehicle-cost-buttons(:item="item")
          .field-value(slot="n1") VC{{item.id}}
          .field-value(slot="n1") {{item.type.name}}
          .field-value(slot="n2") {{item.description}}
          .field-value(slot="n3") Amount: {{currency}}{{item.amount}}
          .field-value(slot="n3") Tax: {{currency}}{{item.tax}}
          .field-value(slot="n4") {{item.date}}


</template>
<script type="text/babel">
  import CardN from 'components/structure/CardN'
  import Dropdown from '../structure/foundation/Dropdown'
  import VehicleCostButtons from '../structure/ui/actions/VehicleCostButtons'
  import {mapState} from 'vuex'

  export default {
    name: "VehicleCost",
    components: {
      VehicleCostButtons,
      Dropdown,
      CardN,
    },
    data() {
      return {}
    },
    created() {
    },
    methods: {},
    computed: {
      ...mapState({
        configuration: state => state.configuration,
      }),
      currency() {
        return this.configuration.commercial.commercial_currency.value
      },
    },
    props: {
      item: Object,
      type: {
        type: String,
        default: ''
      }
    },
  }
</script>
<style lang="sass" rel="stylesheet/sass">
  .component-backoffice-vehicle-slot
    .column-n1
      flex: 1 1 0
    .column-n3
      flex: 0 1 0
    .column-n5
      flex: 0 1 0
</style>



// WEBPACK FOOTER //
// VehicleCost.vue?4653ea0a